const enum Keys {
  INFO_SHOULD_DISPLAY_HELPER = 'info.shouldDisplayHelper',
  TRACKING_SURVEY_SHOULD_ASK_FOR_REMINDER = 'tracking.survey.shouldAskForReminder',
  TRACKING_SURVEY_SHOULD_ASK_FOR_PERIOD = 'tracking.survey.shouldAskForPeriod',
  TRACKING_SHOULD_DISPLAY_HELPER = 'tracking.shouldDisplayHelper',
  TRACKING_REMINDER_TIME = 'tracking.reminder.time', // symptom tracking daily reminder
  TRACKING_ENABLE_PERIOD_REMINDER = 'tracking.reminder.isPeriodReminderEnabled',
  TRACKING_DID_WE_ALREADY_SUGGEST_PERIOD_REMINDER = 'tracking.reminder.didWeAlreadySuggestPeriodReminder',
  TRACKING_HISTORY_VISIBLE_GRAPHS = 'tracking.history.visibleGraphs', // which graphs to show in history module
  TRACKING_SURVEY_VISIBLE_QUESTIONS = 'tracking.survey.visibleQuestions', // which questions to show in the daily survey
  TRACKING_SURVEY_CATEGORIES_OPEN = 'tracking.survey.isQuestionSelectorOpen', // whether the categories collapse is open
  PAYWALL_DID_ENABLE_FREE_MESSAGES = 'paywall.didEnableFreeMessages',
  DID_WE_ALREADY_ASK_FOR_APPSTORE_REVIEW = 'didWeAlreadyAskForAppStoreReview',
  PREVENTION_JOURNEY_STARTED = 'prevention.journey.started',
  PREVENTION_JOURNEY = 'prevention.journey',
  MESSAGE_DRAFTS = 'conversations.messageDrafts',
  PUSH_OPT_IN_FLOW_COMPLETED = 'push.optInFlowCompleted',
  PUSH_REGISTERED_FCM_TOKEN = 'push.registeredFcmToken', // unregistered from the backend on logout
  HOME_REBRANDING_ANNOUNCEMENT_DISMISSED = 'home.rebrandingAnnouncement.dismissed',
}

export default Keys;
